import { emptyError } from "../../../Types/ServicesType/servicesType";
import { VitalsDto } from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const { clinicId } = getConstants();
const { nursingApi } = api;

export const getallbloodGroup = async () => {
  try {
    const result = await instance.get(`${nursingApi.getAllBloodGroup}`);
    return result.data.response;
  } catch (error) {
    return emptyError;
  }
};

export const getvitalsById = async (id: number) => {
  const result = await instance.get(
    `${nursingApi.getvitalsById}${clinicId}?id=${id}`
  );
  return result?.data?.response;
};
export const postVitals = async (data: VitalsDto) => {
  try {
    const result = await instance.post(`${nursingApi.saveVitals}`, data);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};
